export class SkeletonLoaderCounter {
  private static uniqueSkeletonId = -1;

  static getLoaderId(): string {
    return `${++SkeletonLoaderCounter.uniqueSkeletonId}`;
  }
}
